<template>
  <div class="content">
    <basic-panel>
      <h3 slot="title" class="title is-4 is-marginless">Leírás</h3>
      <div slot="content"><markdown>{{ covid19.fields.description }}</markdown></div>
    </basic-panel>
    <basic-panel v-if="(covid19.fields.keywords || []).length">
      <h3 slot="title" class="title is-4 is-marginless">Kulcsszavak</h3>
      <div slot="content">
        <div class="tags">
          <span class="tag is-primary"
                v-for="keyword in covid19.fields.keywords"
                :key="keyword"
          >{{ keyword }}</span>
        </div>
      </div>
    </basic-panel>
  </div>
</template>

<script>
  import BasicPanel from '@/components/General/BasicPanel'

  export default {
    props: [
      'covid19'
    ],
    components: {
      BasicPanel
    }
  }
</script>

<style scoped>
  .file {
    margin-bottom: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BestPractice/Covid19Detailed.vue